"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rangoFechasFilter = require("./rangoFechas");
const valorUnicoFilter = require("./valorUnico");
const busquedaTexto = require("./busquedaTexto");
/**Selecciona un filtro basado en la información de la columna */
function getDataType(data, getData) {
    if (data.length == 0)
        return "empty";
    const distinctData = new Set();
    let distinctNumberCount = 0;
    let distinctStringCount = 0;
    const manyMax = 200;
    //Tratamos de tomar una muestra de este tamaño:
    const sampleSize = 1000;
    const step = Math.round(Math.max(data.length / sampleSize, 1));
    let isAllEquals = true;
    const firstData = getData(data[0]);
    for (let i = 0; i < data.length; i += step) {
        const value = getData(data[i]);
        if (value instanceof Date) {
            return "date";
        }
        else {
            const newValue = !distinctData.has(value);
            if (newValue) {
                //El valor nunca ha aparecido antes
                const type = typeof (data[i]);
                if (type == "number")
                    distinctNumberCount++;
                else
                    distinctStringCount++;
            }
        }
        if (distinctNumberCount > manyMax && distinctStringCount == 0) {
            return "numericRange";
        }
        else if (distinctStringCount > manyMax) {
            return "manyValues";
        }
        distinctData.add(value);
        if (value != firstData) {
            isAllEquals = false;
        }
    }
    return isAllEquals ? "allEqual" : "fewValues";
}
/**Selecciona un tipo de filtro basado en la información de la columna */
function getAutoFiltro(data, getData) {
    const dataType = getDataType(data, getData);
    switch (dataType) {
        case "allEqual":
            return valorUnicoFilter.filtro;
        case "date":
            return rangoFechasFilter.filtro;
        case "numericRange":
        case "fewValues":
            return valorUnicoFilter.filtro;
        case "manyValues":
            return busquedaTexto.filtro;
    }
}
exports.getAutoFiltro = getAutoFiltro;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/autoFiltro.js
// module id = 2229
// module chunks = 0